import AreaFilterDefinition from '../AreaFilterDefinition';
import AttendanceFilterDefinition from '../AttendanceFilterDefinition';
import ContinentFilterDefinition from '../ContinentFilterDefinition';
import { CountryFilterDefinition } from '../CountryFilterDefinition';
import DisciplineFilterDefinition from '../DisciplineFilterDefinition';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters';
import FormatFilterDefinition from '../FormatFilterDefinition';
import MastersDegreeTypeFilterDefinition from './MastersDegreeTypeFilterDefinition';
import MastersDurationFilterDefinition from './MastersDurationFilterDefinition';
import { PortalDefinition } from '../PortalDefinition';
import TuitionFeeFilterDefinition from '../TuitionFeeFilterDefinition';
import MastersSpecialProgrammesFilterDefinition from './MastersSpecialProgrammesFilterDefinition';
import OrganisationFilterDefinition from '../OrganisationFilterDefinition';

class MastersPortalDefinition extends PortalDefinition {
	public constructor() {
		super(
			[
				OrganisationFilterDefinition,
				AttendanceFilterDefinition,
				MastersDegreeTypeFilterDefinition,
				DisciplineFilterDefinition,
				MastersDurationFilterDefinition,
				FormatFilterDefinition,
				TuitionFeeFilterDefinition,
				MastersSpecialProgrammesFilterDefinition,
				AreaFilterDefinition,
				ContinentFilterDefinition,
				new CountryFilterDefinition()
			],
			['30', '82', '202', '11', '56'],
			"Master's degrees",
			'master',
			EducationLevelFilterOptionValue.MASTER,
			'Masters'
		);
	}
}

export default new MastersPortalDefinition();
